module.exports = __webpack_public_path__ + "static/media/create-content.ae9857fa.gif";